<template>
  <v-card class="pa-2 mt-2" flat="" outlined="">
    <div class="d-flex align-center">
      <h3>Multiple Choice</h3>
      <v-spacer />
      <v-btn depressed icon @click="$emit('delete')">
        <v-icon dark color="grey">mdi-delete</v-icon>
      </v-btn>
      <v-btn
        class="ml-4"
        depressed
        :color="extended ? 'blue' : 'grey'"
        @click="extended = !extended"
        icon
      >
        <v-icon dark v-if="!extended">mdi-menu-open</v-icon>
        <v-icon dark v-if="extended">mdi-close</v-icon>
      </v-btn>
    </div>
    <v-card-subtitle
      class="pa-0 ma-0"
      v-bind:class="{ 'red--text': characters > 300 }"
      >{{ characters }} / 300 characters</v-card-subtitle
    >
    <v-expand-transition>
      <div v-if="extended">
        <v-text-field
          label="Question Prompt"
          hint="For example, Who was the first US President?"
          v-model="assessment.question"
          suffix=""
          :maxlength="300 - characters + `${assessment.question}`.length"
        ></v-text-field>
        <div class="d-flex">
          <h4>Choices</h4>
        </div>
        <v-card-subtitle
          class="pa-0 pb-1 pt-1 subtitle-1"
          v-if="!assessment.answer"
          >If you want to send this as a survey, don't select a correct answer.
          You can enter custom responses either way.
        </v-card-subtitle>
        <div class="choices">
          <v-card
            outlined
            class="pa-2 mb-1"
            flat
            v-for="(choice, index) in assessment.options"
            :key="choice._id"
          >
            <div class="d-flex align-center">
              <h4>Option {{ simple[index] }}</h4>
              <v-spacer />
              <v-btn depressed icon @click="deleteChoice(index)">
                <v-icon dark color="grey">mdi-delete</v-icon>
              </v-btn>
            </div>
            <v-text-field
              v-model="choice.prompt"
              label="Option*"
              hint="For example, Thomas Jefferson"
              :maxlength="300 - characters + `${choice.prompt}`.length"
            ></v-text-field>
            <v-textarea
              autocomplete="off"
              spellcheck="true"
              name="input-7-1"
              label="Response"
              hint="For example, Nice try! But the answer was George Washington"
              v-model="choice.response"
              auto-grow
              value
              counter=""
              maxlength="800"
              rows="1"
            ></v-textarea>
            <!-- <v-radio-group v-model="assessment.answer" :mandatory="false">
              <v-radio
                label="Choice is Correct"
                :value="String(index)"
                color="blue"
              ></v-radio>
            </v-radio-group> -->
            <v-checkbox
              v-model="assessment.answer"
              label="Correct Answer"
              color="#FF6247"
              :value="String(index)"
              hide-details
            ></v-checkbox>
          </v-card>
        </div>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="fixed-add"
              fab
              dark
              depressed=""
              color="blue"
              x-small
              v-on="on"
              @click="addChoice"
              v-show="showAdd"
            >
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Add Another Choice</span>
        </v-tooltip>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    simple: ["A", "B", "C", "D", "E", "F", "G"],
    extended: false
  }),
  props: {
    assessment: {
      type: Object,
      default: () => {
        return {
          question: "",
          type: "",
          options: [],
          answer: "",
          response: ""
        };
      }
    }
  },
  computed: {
    characters() {
      try {
        let num = 0;
        if (this.assessment && this.assessment.question) {
          num = num + this.assessment.question.length;
        }
        if (Array.isArray(this.assessment.options)) {
          this.assessment.options.forEach(obj => {
            if (obj.prompt) {
              num = num + `${obj.prompt}`.length;
            }
          });
        }
        return num;
      } catch (err) {
        return Number.NaN();
      }
    },
    showAdd() {
      if (!Array.isArray(this.assessment.options)) {
        return true;
      }
      if (this.assessment.options.length <= 4) {
        return true;
      }
      return false;
    }
  },
  methods: {
    /**
     * Adds a choice
     */
    addChoice() {
      if (this.assessment.options == undefined) {
        this.assessment.options = [];
      }
      this.assessment.options.push({
        prompt: "",
        response: ""
      });
      console.log("added");
    },
    /**
     * Removes a choice
     * @param {Number} index Index to remove
     */
    deleteChoice(index) {
      this.assessment.options.splice(index, 1);
      if (Number(this.assessment.answer) === Number(index)) {
        this.assessment.answer = null;
      }
    }
  }
};
</script>

<style scoped>
.fixed-add {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
.choices {
  margin-bottom: 40px;
}
</style>
